import { Box } from '@mui/material'

import { keyframes } from '@emotion/react'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

function FadeInOnMount({ duration = 400, delay = 0, children, ...rest }) {
  const prefersReducedMotion = globalThis.matchMedia(
    '(prefers-reduced-motion: no-preference)',
  ).matches

  return (
    <Box
      {...rest}
      sx={{
        ...(rest.sx || {}),
        ...(prefersReducedMotion
          ? {
              animationName: `${fadeIn}`,
              animationDuration: `${duration}ms`,
              animationDelay: `${delay}ms`,
              animationFillMode: 'backwards',
            }
          : {}),
      }}
    >
      {children}
    </Box>
  )
}

export default FadeInOnMount
